import { OsType, AppBrands, IdTypeSelections } from '../constants'
import store from '../store'

export const getMobileClass = () => {
  const { isMobileBrowser, mobileOs } = store.state.display

  if (isMobileBrowser && mobileOs === OsType.Apple) {
    return 'radioButtonIos'
  }

  if (isMobileBrowser && mobileOs === OsType.Android) {
    return 'radioButtonAndroid'
  }

  return null
}

export const getDefaultState = () => {
  switch (process.env.VUE_APP_AppBrand) {
    case AppBrands.c1l:
    case AppBrands.ccc:
      return 'CA'

    case AppBrands.chs:
    case AppBrands.spc:
    case AppBrands.cic:
      return 'AZ'

    case AppBrands.esm:
      return 'AL'

    case AppBrands.inl:
      return 'FL'

    case AppBrands.ccf:
      return 'MS'

    case AppBrands.rpc:
      return 'NV'

    case AppBrands.tmx:
    case AppBrands.tbs:
    default:
      return 'GA'
  }
}

const getIdRoute = (idSelection) => {
  switch (idSelection) {
    case IdTypeSelections.driversLicense: return 'IdDriversLicense'
    case IdTypeSelections.state: return 'IdState'
    case IdTypeSelections.passport: return 'IdPassport'
    case IdTypeSelections.matricula: return 'IdMatriculaConsular'
    default: return 'IdDriversLicense'
  }
}

export default getIdRoute
